import React, { useEffect, useMemo, useRef, useState } from "react";
import {
    ErrorCard,
    LoadingCard,
    MainContainer,
} from "../../../components";
import {
    Card,
    CardBody,
    Input,
    Select,
    SelectItem,
    Modal,
    ModalBody,
    ModalContent,
    ModalHeader,
    useDisclosure,
    Button,
    Autocomplete,
    AutocompleteItem,
    ModalFooter,
    Textarea,
    Drawer,
    DrawerContent,
    DrawerHeader,
    DrawerBody,
    DrawerFooter,
    Checkbox,
    Tab,
    Tabs,
    form,
} from "@heroui/react";
import { apiRoute, ENUM_BILL_TYPE_LIST, ENUM_INPUT_TYPE, ENUM_TRANSACTION_TYPE, funValidateNoInput, linksUrl, URIEncrypt } from "../../../constants/enum";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faArrowRightLong,
    faCancel,
    faExclamationTriangle,
    faFile,
    faInfo,
    faSave,
} from "@fortawesome/free-solid-svg-icons";
import BillsDetail from "../BillsDetail";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { useFetchWithBody, usePost } from "../../../api/reactQueryCustomHooks";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { isMobile } from 'react-device-detect';
import { setDate } from "date-fns";
import { resetImpExpDetailParams } from "../../../state/paymentEntrySlice";
import { funCheckNumber, scrollInput, stickyBottomClass, stickyParentClass } from "../../../Utility/utility";
import { error } from "ajv/dist/vocabularies/applicator/dependencies";
import { distance } from "framer-motion";

const CreateDollarPayEntry = () => {
    const { isOpen, onOpen, onOpenChange } = useDisclosure();
    const navigate = useNavigate();
    const { xtype } = useParams()
    const { compCode, isMultipleCompany, compState, startDate, endDate } = useSelector((state) => state.company);
    const { user } = useSelector((state) => state.auth);
    const { impExpDetailParams, impExpIsNewEntry } = useSelector((state) => state.paymentEntry);
    const [selVouType, setSelVouType] = useState('');
    const [entryLabel, setEntryLabel] = useState('');
    const [submitBtnId, setSubmitBtnId] = useState("")
    const dispatch = useDispatch()
    const submitLockRef=useRef(false)
    const [tradeType, setTradeType] = useState("")
    const [jvTrnDataBillh, setJvTrnDataBillh] = useState({
        trnNo: "",
        excJvTrnNo: "",
        excSedJvTrnNo: "",
        excAedJvTrnNo: ""

    })
    const inputRefs = useRef([]);
    const ENUM_ENTRY_TYPE = [
        { key: 21, value: "Payment" },
        { key: 22, value: "$_To_Rs_Transffer" },
        { key: 23, value: "Rs_To_$_Transffer" }
    ]
    const formField = {
        transId: "transId",
        detailId: "detailId",
        gpBillTrnId: "gpBillTrnId",
        gpBillDetailId: "gpBillDetailId",
        voucherNo: "voucherNo",
        transDate: "transDate",
        valueDate: "valueDate",
        payType: "payType",
        bankVouNo: "bankVouNo",
        partyId: "partyId",
        bankBranchId: "bankBranchId",
        entryType: "entryType",
        bookId: "bookId",
        invoiceNo: "invoiceNo",
        invoiceTrnNo: "invoiceTrnNo",
        invoiceType: "invoiceType",
        invoiceDate: "invoiceDate",
        invoiceVouNo: "invoiceVouNo",
        invAmount: "invAmount",
        invAmountD: "invAmountD",
        invSetOffAmt: "invSetOffAmt",
        invSetOffAmtD: "invSetOffAmtD",
        dueDays: "dueDays",
        dueDate: "dueDate",
        trfAmtD: "trfAmtD",
        trfAmt: "trfAmt",
        trfConvRate: "trfConvRate",
        invConvRate: "invConvRate",
        balAmount: "balAmount",
        balAmountD: "balAmountD",
        addAcId: "addAcId",
        addAmount: "addAmount",
        addAmountD: "addAmountD",
        lessAcId: "lessAcId",
        lessAmount: "lessAmount",
        lessAmountD: "lessAmountD",
        partyBank: "partyBank",
        rateDiffAcId: "rateDiffAcId",
        bankCommision: "bankCommision",
        insurance: "insurance",
        otherChages: "otherChages",
        totalAmount: "totalAmount",
        sGstPer: "sGstPer",
        sGstAmt: "sGstAmt",
        cGstPer: "cGstPer",
        cGstAmt: "cGstAmt",
        totalGst: "totalGst",
        remark: "remark",
        convRate: "convRate",
        chargesRemark: "chargesRemark",
        bankChrgItemCode: "bankChrgItemCode",
        chargExpAcId: "chargExpAcId",
        rateDiff: "rateDiff",
        rateDiffMns: "rateDiffMns",
        netAmount: "netAmount",
        netAmountD: "netAmountD",
        totalCharge: "totalCharge",
        totalChargeWithTax: "totalChargeWithTax",
        jvTrn_A: "jvTrn_A",
        jvTrn_L: "jvTrn_L",
        jvTrn_No: "jvTrn_No",
        JvTrn_Rd: "JvTrn_Rd"

    };

    const [billData, setBillData] = useState([]);
    const { isPending: isLoadingDetail, isError: isErrorDetail, data: detail = [], mutate: funGetDetail } = usePost({
        url: apiRoute.transactionEntry.fetchImpExpEntryDetail,
        queryKey: "fetchImpExpBillDetail",
    });

    useEffect(() => {
        if (isMultipleCompany)
            navigate(linksUrl.dashboard)
    }, [])

    useEffect(() => {
        const params = [URIEncrypt.Payment, URIEncrypt.Receive]
        if (!params.includes(String(xtype)))
            navigate(linksUrl.dashboard)

        if (xtype && xtype != "") {
            let t_vouType = ""
            if (xtype == URIEncrypt.Receive) {
                t_vouType = 'R'
                setEntryLabel("Receive Againts Export")

            }
            if (xtype == URIEncrypt.Payment) {
                t_vouType = 'G'
                setEntryLabel("Payment Againts Import")
            }
            setSelVouType(t_vouType)
            if (!impExpIsNewEntry && impExpDetailParams && Object.keys(impExpDetailParams).length > 0) {
                const { transactionid, compcode, pacid, voutype, gpbilltrnid } = impExpDetailParams

                funGetDetail({
                    data: {
                        transaction_id: transactionid,
                        comp_code: compcode,
                        pac_id: pacid,
                        vou_type: voutype,
                        gpbill_trnid: gpbilltrnid,
                    }
                })
            }
        }
    }, [xtype])

    const strField = [
        formField.payTo,
        formField.voucherNo,
        formField.remark,
        formField.partyName,
        formField.bookName,
        formField.lessAcName,
        formField.addAcName,
        formField.tdsAcId,
        formField.addAcId,
        formField.lessAcId,
        formField.chqAmount,
        formField.locationId,
        formField.docType,
        formField.chargesRemark,
        formField.bankVouNo,
        formField.remark,
        formField.chargesRemark
    ];

    const numberField = [
        formField.addAmount,
        formField.addAmountD,
        formField.lessAmount,
        formField.lessAmountD,
        formField.convRate,
        formField.invSetOffAmt,
        formField.invSetOffAmtD,
        formField.rateDiff,
        formField.cGstPer,
        formField.sGstPer,
        formField.bankCommision,
        formField.otherChages,
        formField.insurance,
        formField.balAmount,
        formField.balAmountD,
        formField.totalAmount,
        formField.netAmount,
        formField.netAmountD,
        formField.invConvRate,
        formField.trfConvRate,
        formField.trfAmt,
        formField.trfAmtD,
        formField.totalChargeWithTax,
        formField.entryType

    ]

    //console.log(billData)
    const emptyFormField = Object.keys(formField).reduce((acc, key) => {
        const today = dayjs();
        if (strField.includes(key)) acc[key] = "";
        else if (key == formField.transDate || key == formField.valueDate || key == formField.invoiceDate)
            acc[key] = today.isAfter(dayjs(endDate))
                ? null
                : today.format("YYYY-MM-DD");
        else if (key == formField.dueDate)
            acc[key] = dayjs(Date()).format("YYYY-MM-DD");
        else acc[key] = 0;
        return acc;
    }, {});

    const [formData, setFormData] = useState({
        ...emptyFormField,
    });

    const handleBillsDetail = (data) => {
        if (data && data.length > 0) {
            const selBill = data.filter(ele => ele.IsSelected == true)
            setBillData(data);
            setFormData({
                ...formData,
                invoiceDate: selBill[0]?.Bill_Date ?? null,
                invAmountD: selBill[0]?.NetAmtD ?? 0,
                balAmountD: selBill[0]?.BalAmtD ?? 0,
                invAmount: selBill[0]?.NetAmt ?? 0,
                balAmount: selBill[0]?.BalAmt ?? 0,
                dueDays: selBill[0]?.DueDays ?? 0,
                dueDate: selBill[0]?.DueDate ?? null,
                invConvRate: selBill[0]?.CRate ?? 0,
                invoiceNo: selBill[0]?.Bill_No ?? '',
                invoiceTrnNo: selBill[0]?.BillTrnNo ?? 0,
                invoiceType: selBill[0]?.Bill_Type ?? '',
                invoiceVouNo: selBill[0]?.Vou_No ?? '',

            });
        } else {
            setBillData([]);
        }
    };

    useEffect(() => {
        if (!impExpIsNewEntry && impExpDetailParams && Object.keys(impExpDetailParams).length > 0) {
            if (
                detail &&
                detail?.itemData &&
                detail?.itemData.length > 0
            ) {

                setBillData(detail?.itemDetail);
                handleBillsDetail(detail?.itemDetail);
                const selectedItem = detail.itemDetail.find(ele => ele.IsSelected == 1);
                const billIndex = detail.itemDetail.indexOf(selectedItem);

                setJvTrnDataBillh({
                    trnNo: detail?.itemData[0]?.Bh_TrnNo,
                    excJvTrnNo: detail?.itemData[0]?.Bh_ExcJvTrnNo,
                    excSedJvTrnNo: detail?.itemData[0]?.Bh_ExcSEDJvTrnNo,
                    excAedJvTrnNo: detail?.itemData[0]?.Bh_ExcAEDJvTrnNo
                })
                //console.log(funIsPaymentEntry(),)
                const isEntryTypePayment = detail.itemData[0]?.EntryFor == 21 ? true : false
                setTradeType(detail?.itemData[0]?.Bh_TradeType ?? '')
                setFormData({
                    transId: detail.itemData[0]?.TransactionId ?? 0,
                    detailId: detail.itemData[0]?.DetailID ?? 0,
                    voucherNo: detail.itemData[0]?.Vou_No ?? "",
                    gpBillTrnId: detail.itemData[0]?.GpBillTrnId ?? 0,
                    gpBillDetailId: detail.itemData[0]?.GpBillTrnDetailId ?? 0,
                    transDate: detail.itemData[0]?.Chq_Date ? new Date(detail.itemData[0]?.Chq_Date).toISOString().split("T")[0] : null,
                    valueDate: detail?.itemData[0]?.Chq_Rec_Date != '' &&
                        detail?.itemData[0]?.Chq_Rec_Date != '1900-01-01T00:00:00.000Z'
                        ? new Date(detail?.itemData[0]?.Chq_Rec_Date).toISOString().split("T")[0] : null,
                    partyId: detail.itemData[0]?.Pac_Id ?? 0,
                    bookId: detail.itemData[0]?.Ac_Id ?? 0,
                    entryType: detail.itemData[0]?.EntryFor ?? 0,
                    netAmount: (detail.itemData[0]?.TrfAmtRs ?? 0).toFixed(2),
                    netAmountD: (detail.itemData[0]?.Chq_AmtD ?? 0).toFixed(2),
                    trfAmt: isEntryTypePayment ? 0 : (detail.itemData[0]?.TrfAmtRs ?? 0).toFixed(2),
                    trfAmtD: isEntryTypePayment ? 0 : (detail.itemData[0]?.Chq_AmtD ?? 0).toFixed(2),
                    trfConvRate: isEntryTypePayment ? 0 : (detail.itemData[0]?.CRate ?? 0).toFixed(2),
                    convRate: (detail.itemData[0]?.CRate ?? 0).toFixed(2),
                    jvTrn_A: detail.itemData[0]?.AJvTrnNo ?? 0,
                    jvTrn_L: detail.itemData[0]?.LJvTrnNo ?? 0,
                    jvTrn_No: detail.itemData[0]?.Trn_No ?? 0,
                    JvTrn_Rd: detail.itemData[0]?.ExtJvTrnNo ?? 0,
                    rateDiffAcId: detail.itemData[0]?.Exjv_Ac_Id ?? '',
                    rateDiff: detail.itemData[0]?.ExtraAmt > 0 ? detail.itemData[0]?.ExtraAmt : 0,
                    rateDiffMns: detail.itemData[0]?.ExtraAmt < 0 ? detail.itemData[0]?.ExtraAmt : 0,
                    addAcId: detail.itemData[0]?.Ajv_Ac_Id ?? '',
                    lessAcId: detail.itemData[0]?.Ljv_Ac_Id ?? '',
                    addAmount: (detail.itemData[0]?.AddAmt ?? 0).toFixed(2),
                    addAmountD: (detail.itemData[0]?.AddAmtD ?? 0).toFixed(2),
                    lessAmount: (detail.itemData[0]?.LessAmt ?? 0).toFixed(2),
                    lessAmountD: (detail.itemData[0]?.LessAmtD ?? 0).toFixed(2),

                    remark: detail.itemData[0]?.Remark ?? '',
                    chargesRemark: detail.itemData[0]?.Remark2 ?? '',
                    bankCommision: (detail.itemData[0]?.BankCharge_1 ?? 0).toFixed(2),
                    insurance: (detail.itemData[0]?.BankCharge_2 ?? 0).toFixed(2),
                    otherChages: (detail.itemData[0]?.BankCharge_3 ?? 0).toFixed(2),
                    totalCharge: (detail.itemData[0]?.Bh_BcAmt ?? 0).toFixed(2),
                    totalChargeWithTax: (detail.itemData[0]?.Bh_TotalBcAmt ?? 0).toFixed(2),
                    chargExpAcId: detail.itemData[0]?.ChargExpAcId ?? 0,
                    bankBranchId: detail.itemData[0]?.BankBrachAcId ?? 0,
                    bankChrgItemCode: detail.itemData[0]?.Item_Code ?? 0,
                    bankVouNo: detail.itemData[0]?.BankVouNo ?? 0,
                    convRate: detail.itemData[0]?.CRate ?? 0,
                    partyBank: detail.itemData[0]?.BankName ?? 0,
                    cGstAmt: detail.itemData[0]?.StAmt ?? 0,
                    cGstPer: detail.itemData[0]?.StPer ?? 0,
                    sGstAmt: detail.itemData[0]?.AstAmt ?? 0,
                    sGstPer: detail.itemData[0]?.AstPer ?? 0,
                    totalGst: (parseFloat(detail.itemData[0]?.StAmt) + parseFloat(detail.itemData[0]?.AstAmt)).toFixed(2),
                    totalAmount: selVouType == 'G' && isEntryTypePayment ? (parseFloat(detail.itemData[0]?.Chq_Amt) + parseFloat(detail.itemData[0]?.Bh_TotalBcAmt)).toFixed(2) :
                        selVouType == 'R' && isEntryTypePayment ? (parseFloat(detail.itemData[0]?.Chq_Amt) - parseFloat(detail.itemData[0]?.Bh_TotalBcAmt)).toFixed(2) :
                            (parseFloat(detail.itemData[0]?.Chq_Amt)).toFixed(2),

                    invoiceNo: detail.itemDetail[billIndex]?.Bill_No ?? 0,
                    invoiceTrnNo: detail.itemDetail[billIndex]?.BillTrnNo ?? 0,
                    invoiceType: detail.itemDetail[billIndex]?.Bill_Type ?? 0,
                    invoiceDate: detail.itemDetail[billIndex]?.Bill_Date ?? 0,
                    invConvRate: (detail.itemDetail[billIndex]?.CRate ?? 0).toFixed(2),
                    invoiceVouNo: detail.itemDetail[billIndex]?.Vou_No ?? 0,
                    invAmount: (detail.itemDetail[billIndex]?.NetAmt ?? 0).toFixed(2),
                    invAmountD: (detail.itemDetail[billIndex]?.NetAmtD ?? 0).toFixed(2),
                    invSetOffAmt: (detail.itemDetail[billIndex]?.NewPayAmt ?? 0).toFixed(2),
                    dueDays: detail.itemDetail[billIndex]?.DueDays ?? 0,
                    dueDate: detail.itemDetail[billIndex]?.DueDate ?? 0,
                    invSetOffAmtD: (detail.itemDetail[billIndex]?.NewPayAmtD ?? 0).toFixed(2),
                    balAmount: (detail.itemDetail[billIndex]?.BalAmt ?? 0).toFixed(2),
                    balAmountD: (detail.itemDetail[billIndex]?.BalAmtD ?? 0).toFixed(2),
                    invConvRate: detail.itemDetail[billIndex]?.CRate ?? 0,
                    payType: detail.itemDetail[billIndex]?.Type ?? ''

                });

            }
        }
    }, [detail]);

    const { isLoading: isLoadingData, data: masterData = [] } = useFetchWithBody({
        url: apiRoute.transactionEntry.fetchMasterData,
        queryKey: "fetchMasterData",
        inputData: {
            comp_code: compCode.join(","),
        },
    });

    const funGetNaviLink = () => {
        if (selVouType == "G")
            return linksUrl.importExportEntry.pay + "/" + xtype + linksUrl.importExportEntry.payEntryMaster;
        if (selVouType == "R")
            return linksUrl.importExportEntry.rec + "/" + xtype + linksUrl.importExportEntry.recEntryMaster;
    }

    const {
        isPending,
        isError,
        mutate: funInUpPayment,
    } = usePost({
        url: apiRoute.transactionEntry.inup_impexp_entry,
        queryKey: "InUpImpExpPaymentEntry",
        onSuccessTasks: (data) => {
            dispatch(resetImpExpDetailParams())
           
        submitLockRef.current = false;
            if (submitBtnId == "btnSaveNew") {
                setFormData(emptyFormField)
            }
            else
                navigate(funGetNaviLink());
        },
    });

    const onSuccessBills = (data) => {
        setBillData(data);
        onOpen();
    };

    const { mutate: fnGetBills } = usePost({
        url: apiRoute.transactionEntry.getBill,
        queryKey: "getBillData",
        onSuccessTasks: onSuccessBills,
    });

    const funIsPaymentEntry = () => {
        if (formData && formData?.entryType == 21)
            return true
        else
            return false
    }

    const inputBoxes = {
        Section1: {
            Row1: [
                {
                    id: formField.bookId,
                    name: formField.bookId,
                    placeholder: "Book Name",
                    type: ENUM_INPUT_TYPE.autocomplete,
                    size: "sm",
                    label: "",
                    data: masterData.bookMaster,
                    itemkey: "Party_Id",
                    itemvalue: "Party_Name",
                    isrequired: true,
                },
                {
                    id: formField.bankBranchId,
                    name: formField.bankBranchId,
                    placeholder: "Bank Branch Id",
                    type: ENUM_INPUT_TYPE.autocomplete,
                    size: "sm",
                    label: "",
                    data: masterData.accountMaster,
                    itemkey: "Party_Id",
                    itemvalue: "Party_Name",
                    isrequired: formData.totalCharge > 0 ? true : false,
                },
            ],
            Row2: [
                {
                    name: formField.voucherNo,
                    placeholder: "Voucher No",
                    type: ENUM_INPUT_TYPE.text,
                    size: "sm",
                    label: "",
                    isrequired: false,
                },
                {
                    name: formField.transDate,
                    placeholder: "Transaction Date",
                    type: ENUM_INPUT_TYPE.date,
                    size: "sm",
                    label: "",
                    isrequired: true,
                },
            ],
            Row3: [
                {
                    name: formField.bankVouNo,
                    placeholder: "Bank Voucher No.",
                    type: ENUM_INPUT_TYPE.text,
                    size: "sm",
                    label: "",
                    isrequired: formData.totalCharge > 0 ? true : false,
                },
                {
                    name: formField.valueDate,
                    placeholder: "Value Date",
                    type: ENUM_INPUT_TYPE.date,
                    size: "sm",
                    label: "",
                    isrequired: false,
                },
            ],
            Row4: [
                {
                    id: formField.partyId,
                    name: formField.partyId,
                    placeholder: "Party Name",
                    type: ENUM_INPUT_TYPE.autocomplete,
                    size: "sm",
                    lable: "",
                    data: masterData.accountMaster,
                    itemkey: "Party_Id",
                    itemvalue: "Party_Name",
                    isrequired: true,
                },
                {
                    id: formField.entryType,
                    name: formField.entryType,
                    placeholder: "Entry Type",
                    type: ENUM_INPUT_TYPE.autocomplete,
                    size: "sm",
                    lable: "",
                    data: ENUM_ENTRY_TYPE,
                    itemkey: "key",
                    itemvalue: "value",
                    isrequired: true,
                },
            ],
            Row5: [
                {
                    name: formField.invoiceNo,
                    placeholder: "Invoice No.",
                    type: ENUM_INPUT_TYPE.text,
                    size: "sm",
                    label: "",
                    isrequired: true,
                },
            ]

        },
        Section4: {
            Row1: [
                {
                    id: formField.bankChrgItemCode,
                    name: formField.bankChrgItemCode,
                    placeholder: "Bank Charge Item",
                    type: ENUM_INPUT_TYPE.autocomplete,
                    size: "sm",
                    label: "",
                    data: masterData.itemMaster,
                    itemkey: "Item_Code",
                    itemvalue: "Item_Desc",
                    isrequired: false,
                },
                {
                    id: formField.chargExpAcId,
                    name: formField.chargExpAcId,
                    placeholder: "Charge Exp Ac",
                    type: ENUM_INPUT_TYPE.autocomplete,
                    size: "sm",
                    label: "",
                    data: masterData.accountMaster,
                    itemkey: "Party_Id",
                    itemvalue: "Party_Name",
                    isrequired: false,
                },

            ],
            Row2: [
                {
                    id: formField.addAcId,
                    name: formField.addAcId,
                    placeholder: "(+) Amt. A/C. ",
                    type: ENUM_INPUT_TYPE.autocomplete,
                    size: "sm",
                    label: "",
                    data: masterData.accountMaster,
                    itemkey: "Party_Id",
                    itemvalue: "Party_Name",
                    isrequired: funIsPaymentEntry() && formData.addAmountD > 0 ? true : false,
                },
                {
                    name: formField.jvTrn_A,
                    placeholder: "Add J/V No",
                    type: ENUM_INPUT_TYPE.text,
                    size: "sm",
                    label: "",
                    isrequired: false,

                },
            ],
            Row3: [
                {
                    id: formField.lessAcId,
                    name: formField.lessAcId,
                    placeholder: "(-) Amt. A/C.",
                    type: ENUM_INPUT_TYPE.autocomplete,
                    size: "sm",
                    label: "",
                    data: masterData.accountMaster,
                    itemkey: "Party_Id",
                    itemvalue: "Party_Name",
                    isrequired: funIsPaymentEntry() && formData.lessAmountD > 0 ? true : false,
                },
                {
                    name: formField.jvTrn_L,
                    placeholder: "Less J/V No",
                    type: ENUM_INPUT_TYPE.text,
                    size: "sm",
                    label: "",
                    isrequired: false,

                },
            ],
            Row4: [
                {
                    id: formField.rateDiffAcId,
                    name: formField.rateDiffAcId,
                    placeholder: "Exc. Rate Diff. A/C.",
                    type: ENUM_INPUT_TYPE.autocomplete,
                    size: "sm",
                    label: "",
                    data: masterData.accountMaster,
                    itemkey: "Party_Id",
                    itemvalue: "Party_Name",
                    isrequired: funIsPaymentEntry() && (formData.rateDiff > 0 || formData.rateDiffMns < 0) ? true : false,
                },
                {
                    name: formField.JvTrn_Rd,
                    placeholder: "ERD J/V No",
                    type: ENUM_INPUT_TYPE.text,
                    size: "sm",
                    label: "",
                    isrequired: false,

                },
            ],
        },
    };


    const parseNum = (val) => funCheckNumber(parseFloat(val || 0));
    const getAmtType = () => {
        return formData?.entryType == 22 ? '$' : formData?.entryType == 23 ? 'RS' : "P"
    }
    const handleChange = (e) => {
        const { name, value } = e.target;
        const getVal = (field) => name === field ? value : formData[field] || 0;
        const isValid = funValidateNoInput(value);

        const calFields = [
            formField.invSetOffAmtD,
            formField.convRate,
            formField.lessAmountD,
            formField.addAmountD,
            formField.totalAmount,
            formField.trfAmtD,
            formField.trfConvRate,
            formField.trfAmt
        ];

        const bankFields = [
            formField.bankCommision,
            formField.insurance,
            formField.otherChages,
            formField.cGstPer,
            formField.sGstPer,
            formField.totalAmount
        ];

        if (calFields.includes(name)) {
            if (!isValid) return;
            const convRate = parseNum(getVal(formField.convRate))
            const setOffAmtD = parseNum(getVal(formField.invSetOffAmtD));
            const lessAmtD = parseNum(getVal(formField.lessAmountD));
            const addAmtD = parseNum(getVal(formField.addAmountD));
            const chargWithTax = parseNum(getVal(formField.totalChargeWithTax));
            const trfConvRate = funIsPaymentEntry() ? 0 : parseNum(getVal(formField.trfConvRate));
            let trfAmtD = funIsPaymentEntry() ? 0 : getVal(formField.trfAmtD);
            let trfAmt = funIsPaymentEntry() ? 0 : getVal(formField.trfAmt);

            const setOffAmt = parseNum(setOffAmtD * convRate);
            const lessAmt = parseNum(lessAmtD * convRate);
            const addAmt = parseNum(addAmtD * convRate);

            if (getAmtType() == '$') {
                trfAmt = (parseNum(trfAmtD * trfConvRate)).toFixed(2)
            }
            if (getAmtType() == 'RS') {
                trfAmtD = (parseNum(trfAmt) / parseNum(trfConvRate)).toFixed(2)
            }


            const rateDiff = funIsPaymentEntry() ? (setOffAmtD * parseNum(formData.invConvRate || 0)) - parseNum((setOffAmtD * convRate)) : 0;
            const totalPaidAmtD = funIsPaymentEntry() ? parseNum(setOffAmtD + addAmtD - lessAmtD).toFixed(2) : trfAmtD;
            const totalPaidAmt = funIsPaymentEntry() ? parseNum(setOffAmt + addAmt - lessAmt).toFixed(2) : trfAmt;
            const totalAmt =
                selVouType == "G" && funIsPaymentEntry() ? parseNum(totalPaidAmt + chargWithTax)
                    : parseNum(totalPaidAmt - chargWithTax);

            setFormData((prev) => ({
                ...prev,
                [name]: value,
                addAmount: addAmt.toFixed(2),
                lessAmount: lessAmt.toFixed(2),
                invSetOffAmt: setOffAmt.toFixed(2),
                netAmountD: totalPaidAmtD,
                netAmount: totalPaidAmt,
                rateDiff: rateDiff > 0 ? rateDiff.toFixed(2) : 0,
                rateDiffMns: rateDiff < 0 ? rateDiff.toFixed(2) : 0,
                totalAmount: totalAmt.toFixed(2),
                trfAmt: trfAmt,
                trfAmtD: trfAmtD,

            }));
        }
        else if (bankFields.includes(name)) {
            funCalculateGSt(name, value, tradeType)
        }
        else if (numberField.includes(name)) {
            if (isValid) {
                setFormData((prev) => ({
                    ...prev,
                    [name]: value,
                }));
            }
        }
        else {
            setFormData((prev) => ({
                ...prev,
                [name]: value,
            }));
        }
    };

    const [errors, setErrors] = useState({})
    const validateForm = () => {
        const newErrors = {}

        if (formData[formField.bookId] == null || formData[formField.bookId] == "" || formData[formField.bookId] == "0") {
            newErrors[formField.bookId] = "Book Name is required"
        }
        if (formData[formField.partyId] == null || formData[formField.partyId] == "" || formData[formField.partyId] == "0") {
            newErrors[formField.partyId] = "Party Name is required"
        }
        if (formData[formField.transDate] == null || formData[formField.transDate] == "" || formData[formField.transDate] == "Invalid Date") {
            newErrors[formField.transDate] = "Transaction Date is required"
        }
        if (formData[formField.valueDate] == null || formData[formField.valueDate] == "" || formData[formField.valueDate] == "Invalid Date") {
            newErrors[formField.valueDate] = "Value Date is required"
        }

        setErrors(newErrors)

        // Return true if there are no errors
        return Object.keys(newErrors).length === 0
    }

    useEffect(() => {
        validateForm();
    }, [formData])

    const handleSubmit = (e) => {
        e.preventDefault();
        setSubmitBtnId(e.nativeEvent.submitter.id)
        if (submitLockRef.current) return;
        submitLockRef.current = true;
        const validate_form = validateForm();//
        if (formData[formField.entryType] == 21 && billData?.filter(ele => ele.IsSelected == true)?.length <= 0) {
            toast.error("Select Bill", {
                position: "top-center",
                className: "toast-error",

            })
        }
        else {
            let msg = ""
            if (funIsPaymentEntry()) {
                if (formData[formField?.addAmount] > 0 && (formData[formField.addAcId] == null || formData[formField.addAcId] == ""))
                    msg += " select Add Account ,"
                if (formData[formField?.lessAmount] > 0 && (formData[formField.lessAcId] == null || formData[formField.lessAcId] == ""))
                    msg += " select Less Account ,"
                if ((formData[formField?.rateDiff] > 0 || formData[formField.rateDiffMns] < 0) && (formData[formField.rateDiffAcId] == null || formData[formField.rateDiffAcId] == ""))
                    msg += " select Rate Diff Account ,"
            }
            if (formData[formField.totalCharge] > 0) {
                if (formData[formField.chargExpAcId] == null || formData[formField.chargExpAcId] == "")
                    msg += " select Bank Branch Id ,"
                if (formData[formField.bankChrgItemCode] == null || formData[formField.bankChrgItemCode] == "")
                    msg += " select Bank Charge Item ,"
                if (formData[formField.bankBranchId] == null || formData[formField.bankBranchId] == "")
                    msg += " select Bank Branch Id ,"
            }

            if (msg == "" && validate_form) {
                let payhData = []
                for (let i = 1; i <= 2; i++) {
                    let isBCPayEntry = false

                    if (i == 2) isBCPayEntry = true
                    const new_formData = {
                        trans_id: isBCPayEntry && !impExpIsNewEntry ? detail?.itemData[1]?.TransactionId || 0 : formData.transId,
                        detail_id: isBCPayEntry && !impExpIsNewEntry ? detail?.itemData[1]?.DetailID || 0 : formData.detailId,
                        voucherNo: isBCPayEntry ? "" : formData[formField.voucherNo],
                        transDate: formData[formField.transDate],
                        chqRecDate: isBCPayEntry ? null : formData[formField.valueDate],
                        billNo: isBCPayEntry ? formData[formField.bankVouNo] : formData[formField.invoiceNo],
                        billTrnId: isBCPayEntry ? "0" : formData[formField.invoiceTrnNo],
                        billType: isBCPayEntry ? "P" : formData[formField.invoiceType],
                        billVouNo: formData[formField.invoiceVouNo],
                        bankVouNo: formData[formField.bankVouNo],
                        partyId: isBCPayEntry ? formData[formField.bankBranchId] : formData[formField.partyId],
                        bankBranchId: isBCPayEntry ? "" : formData[formField.bankBranchId],
                        newPayAmt: isBCPayEntry ? formData[formField.totalCharge] : funIsPaymentEntry() ? parseNum(formData[formField.invSetOffAmt]) : parseNum(formData[formField.trfAmt]),
                        newPayAmtD: isBCPayEntry ? 0 : funIsPaymentEntry() ? parseNum(formData[formField.invSetOffAmtD]) : parseNum(formData[formField.trfAmtD]),
                        entryFor: isBCPayEntry ? 0 : formData[formField.entryType],
                        bookId: formData[formField.bookId],
                        chqAmount: isBCPayEntry ? parseNum(formData[formField.totalChargeWithTax])
                            : formData[formField.entryType] == 21 ? parseNum(formData[formField.netAmount]) : parseNum(formData[formField.totalAmount]),
                        chqAmountD: isBCPayEntry ? 0 : formData[formField.entryType] == 21 ? parseNum(formData[formField.netAmountD]) : parseNum(formData[formField.trfAmtD]),
                        trfAmtD: parseNum(formData[formField.trfAmtD]),
                        trfAmt: parseNum(formData[formField.trfAmt]),
                        trfConvRate: parseNum(formData[formField.trfConvRate]),
                        addAcId: isBCPayEntry ? "" : formData[formField.addAcId],
                        addAmount: isBCPayEntry ? 0 : parseNum(formData[formField.addAmount]),
                        addAmountD: isBCPayEntry ? 0 : parseNum(formData[formField.addAmountD]),
                        lessAcId: isBCPayEntry ? "" : formData[formField.lessAcId],
                        lessAmount: isBCPayEntry ? 0 : parseNum(formData[formField.lessAmount]),
                        lessAmountD: isBCPayEntry ? 0 : parseNum(formData[formField.lessAmountD]),
                        partyBank: isBCPayEntry ? "" : formData[formField.partyBank],
                        extraAcId: isBCPayEntry ? "" : formData[formField.rateDiffAcId],
                        extraAmt: isBCPayEntry ? 0 : parseNum(formData[formField.rateDiff]) > 0 ? parseNum(formData[formField.rateDiff]) : parseNum(formData[formField.rateDiffMns]),
                        bankCharge1: isBCPayEntry ? 0 : parseNum(formData[formField.bankCommision]),
                        bankCharge2: isBCPayEntry ? 0 : parseNum(formData[formField.insurance]),
                        bankCharge3: isBCPayEntry ? 0 : parseNum(formData[formField.otherChages]),
                        bcAmt: isBCPayEntry ? 0 : formData[formField.totalCharge],
                        sGstPer: parseNum(formData[formField.sGstPer]),
                        sGstAmt: parseNum(formData[formField.sGstAmt]),
                        cGstPer: parseNum(formData[formField.cGstPer]),
                        cGstAmt: parseNum(formData[formField.cGstAmt]),
                        remark: isBCPayEntry ? "" : formData[formField.remark],
                        convRate: isBCPayEntry ? 0 : funIsPaymentEntry() ? parseNum(formData[formField.convRate]) : parseNum(formData[formField.trfConvRate]),
                        remark2: isBCPayEntry ? "" : formData[formField.chargesRemark],
                        bcItemCode: formData[formField.bankChrgItemCode],
                        chargExpAcId: isBCPayEntry ? "" : formData[formField.chargExpAcId],
                        bcAmtWithTax: isBCPayEntry ? 0 : formData[formField.totalChargeWithTax],
                        jvTrn_A: isBCPayEntry ? 0 : formData[formField.jvTrn_A],
                        jvTrn_No: isBCPayEntry && !impExpIsNewEntry ? detail?.itemData[1]?.Trn_No || 0 : formData[formField.jvTrn_No],
                        jvTrn_A: isBCPayEntry ? 0 : formData[formField.jvTrn_A],
                        jvTrn_L: isBCPayEntry ? 0 : formData[formField.jvTrn_L],
                        JvTrn_Ex: isBCPayEntry ? 0 : formData[formField.JvTrn_Rd],
                        isBCPayEntry: isBCPayEntry,
                        fYearSDate: dayjs(startDate).format("YYYY-MM-DD"),
                        fYearEDate: dayjs(endDate).format("YYYY-MM-DD"),
                    }
                    payhData = [...payhData, new_formData]
                }
                funInUpPayment({
                    data: {
                        comp_code: compCode.join(","),
                        vou_type: selVouType,
                        payentry_data: payhData,
                        gpbill_trnid: formData[formField.gpBillTrnId],
                        gpbill_detailid: formData[formField.gpBillDetailId],
                        trade_type: tradeType,
                        jv_trn_data_billh: jvTrnDataBillh,
                        login_userid: user.username,
                        isbcpay_entry: formData?.totalCharge > 0 ? true : false,
                        rec_status: !impExpIsNewEntry ? 1 : 2,

                    },
                });
            }
            else {
                let tempMsg = "Account Remittance Detail ," + msg
                const messages = tempMsg.split(',');

                toast.error(<div>
                    {messages.map((err, idx) => err != "" ? (

                        <div key={idx} className="p-1">
                            <FontAwesomeIcon className="mr-2" icon={idx == 0 ? faInfo : faExclamationTriangle} ></FontAwesomeIcon>
                            {err.trim()}</div> // Trim to remove extra spaces
                    ) : "")}
                </div>,
                    {
                        position: "top-center",
                        icon: false,
                        className: "toast-error",
                        style: { whiteSpace: 'pre-line', width: '400px', fontSize: "0.8rem", color: "#da3333ff" }, // Optional here, mostly needed if using \n
                    })
            }
        }
    }

    const handleBtnClick = () => {
        let t = 0;

        if (formData.partyId != "" && formData.partyId != "0") {
            if (billData && billData.length > 0) {
                onOpen();

                if (billData && billData.length > 0 && formData.partyId != "0") {
                    if (billData[0].PAc_ID != formData.partyId) t = 1;
                    handleBillsDetail(billData);

                    if (!impExpIsNewEntry && detail && detail.itemDetail) {
                        if (detail.itemDetail[0].PAc_ID === formData.partyId) {
                            handleBillsDetail(billData);

                        }
                    }
                }
            }
            if ((t === 1 && billData.length > 0) || billData.length <= 0) {
                setFormData({
                    ...formData,
                    invSetOffAmtD: 0,
                    convRate: 0,

                });
                fnGetBills({
                    data: {
                        action: "NewData",
                        comp_code: compCode.join(","),
                        transaction_id: 0,
                        pac_id: formData.partyId,
                        vou_type: selVouType,
                        bill_currency: '$'
                    },
                });
            }
        } else {
            toast.error("Select Party Name", {
                position: "top-center",
            });
        }
    };

    const funCalculateGSt = (name, value, tradetype) => {
        const getVal = (field) => name === field ? value : formData[field] || 0;
        const parseNum = (val) => funCheckNumber(parseFloat(val || 0));
        const isValid = funValidateNoInput(value);
        if (!isValid) return;
        const bankComm = parseNum(getVal(formField.bankCommision));
        const insurance = parseNum(getVal(formField.insurance));
        const otherCharges = parseNum(getVal(formField.otherChages));
        let cgstPer = getVal(formField.cGstPer);
        const sgstPer = parseNum(getVal(formField.sGstPer));
        if (tradetype == "OGS")
            cgstPer = 0
        const totalCharges = parseNum(bankComm + insurance + otherCharges);
        const cgstAmt = parseNum(totalCharges * cgstPer / 100);
        const sgstAmt = parseNum(totalCharges * sgstPer / 100);
        const totalGst = parseNum(parseFloat(cgstAmt) + parseFloat(sgstAmt));
        const totalChargeWithTax = parseNum(totalCharges + totalGst);
        const netAmt = parseNum(getVal(formField.netAmount));
        //  const totalAmt = parseNum(totalChargeWithTax + netAmt);
        const totalAmt = selVouType == "G" && funIsPaymentEntry() ?
            parseNum(netAmt + totalChargeWithTax) : parseNum(netAmt - totalChargeWithTax);

        setFormData((prev) => ({
            ...prev,
            [name]: value,
            totalCharge: totalCharges.toFixed(2),
            cGstAmt: cgstAmt.toFixed(2),
            sGstAmt: sgstAmt.toFixed(2),
            cGstPer: cgstPer,
            totalGst: totalGst,
            totalChargeWithTax: totalChargeWithTax.toFixed(2),
            totalAmount: totalAmt.toFixed(2)
        }));
    }
    const funSetTradeType = (partyId) => {
        if (partyId != "" && partyId != null) {
            let t_tradeType = formData.tradeType

            if (compState && compState?.trim() != "") {
                const tempData = masterData.accountMaster.filter((ele) => ele.Party_Id == partyId)

                if (tempData && tempData?.length > 0) {
                    if (tempData[0]?.ADD_6.trim() != "") {

                        if (tempData[0]?.ADD_6.trim().toLowerCase() == compState?.trim().toLowerCase())
                            t_tradeType = "RD"
                        else
                            t_tradeType = "OGS"
                    }
                    else
                        t_tradeType = "URD"
                }

            }
            setTradeType(t_tradeType)
            funCalculateGSt("", "", t_tradeType)
        }
        else
            setTradeType("")
    }
    const handleAutoCompleteChange = (value, name) => {
        if (name == formField.entryType && (value == 22 || value == 23)) {
            setFormData((prevData) => ({
                ...prevData,
                [name]: value,
                [formField.invSetOffAmt]: 0,
                [formField.invSetOffAmtD]: 0,
                [formField.addAmount]: 0,
                [formField.addAmountD]: 0,
                [formField.lessAmount]: 0,
                [formField.lessAmountD]: 0,
                [formField.rateDiff]: 0,
                [formField.rateDiffMns]: 0,
                [formField.rateDiffAcId]: '',
                [formField.addAcId]: '',
                [formField.lessAcId]: '',
                [formField.invoiceDate]: null,
                [formField.invoiceNo]: '',
                [formField.invoiceTrnNo]: 0,
                [formField.invoiceVouNo]: '',
                [formField.dueDate]: null,
                [formField.dueDays]: 0,
                //[formField.invoiceType]:'',

            }));
        }
        else {
            if (name == formField.bankBranchId) {
                funSetTradeType(value)

            }

            setFormData((prevData) => ({
                ...prevData,
                [name]: value,

            }));
        }
    }

    const handleClickPrev = () => {
        navigate(funGetNaviLink());
    };

    const [selDate, setSelDate] = useState(null)
    useEffect(() => {

        if (dayjs(formData[formField.transDate]).isValid() && formData[formField.transDate] != null &&
            (formData[formField.valueDate] == null || formData[formField.valueDate] == "Invalid Date")) {
            const year = dayjs(selDate).format('YYYY')
            const month = dayjs(selDate).format('MM')
            const date = dayjs(selDate).format('DD')

            const sdate = year + "-" + month + "-" + date

            if (year != "0202" && sdate == formData[formField.transDate]) {
                setFormData({ ...formData, [formField.valueDate]: dayjs(selDate).format("YYYY-MM-DD") })
            }

        }
    }, [selDate])

    const handleDateBlur = (e) => {
        const { value, name } = e.target
        if (name == formField.transDate && (formData[formField.valueDate] == null || formData[formField.valueDate] == 'Invalid Date')) {
            setSelDate(dayjs(value, "DD/MM/YYYY").format("YYYY-MM-DD"))

        }
    }

    const handleDateChange = (newValue, name) => {
        if (name == formField.transDate && (formData[formField.valueDate] == null || formData[formField.valueDate] == 'Invalid Date')) {
            setSelDate(dayjs(newValue).format("YYYY-MM-DD"))
        }
        setFormData((prev) => (
            {
                ...prev,
                [name]: newValue != '' && newValue != 'Invalid Date' ?
                    dayjs(newValue).format("YYYY-MM-DD") : null,
            }
        ));
    }

    useEffect(() => {
        scrollInput(); // Returns a cleanup function
        // Runs on unmount
    }, []);

    const handleBlur = (e) => {
        const { value, name } = e.target

        const isValid = funValidateNoInput(value);
        if (isValid) {
            const formatted = funCheckNumber(parseFloat(value || 0)).toFixed(2);
            setFormData((prevData) => ({
                ...prevData,
                [name]: formatted,
            }));
        }


    }
    const handleFocus = (name) => {
        inputRefs.current[name]?.select(); // Auto-select the field on focus
    };
    const inputBoxParam = { type: "text", name: "", placeholder: "", required: false, color: "", variant: "flat", readonly: true }

    const renderInput = ({ type, name, placeholder, required, color, variant, readonly }) => {
        return type == "date" ? <div className=" w-full flex items-end">
            <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                    name={name}
                    label={placeholder}
                    views={["day", "month", "year"]}
                    format="DD/MM/YYYY"
                    value={
                        formData[name]
                            ? dayjs(formData[name])
                            : formData[name]
                    }
                    onChange={(newValue) => {
                        setFormData((prev) => {
                            return {
                                ...prev,
                                [name]: newValue != '' && newValue != 'Invalid Date' ?
                                    dayjs(newValue).format("YYYY-MM-DD") : null,
                            };
                        })
                    }}
                    className="w-full "
                    slotProps={{
                        textField: {
                            size: "small", error: errors[name], helperText: errors[name], required: required

                        },
                    }}
                />
            </LocalizationProvider>
        </div> : (<Input
            type={type || "text"}
            name={name}
            autoComplete="off"
            aria-label={placeholder}
            placeholder={placeholder}
            isInvalid={errors[name]}
            errorMessage={errors[name]}
            label={placeholder}
            labelPlacement="outside"
            //ref={(el) => (inputRefs.current[name] = el)}
            // onFocus={() => handleFocus(name)}
            // onWheel={handleWheel}
            isRequired={required || false}
            value={formData[name]}
            className="my-1"
            classNames={{
                label: "text-xs font-semibold",
            }}
            variant={variant || "bordered"}
            color={color || "default"}
            isReadOnly={readonly || false}
            size={"sm"}
            onChange={handleChange}
            onBlur={handleBlur}
        ></Input>)
    }

    if (isPending || isLoadingDetail) {
        return <LoadingCard />;
    }
    if (isError || isErrorDetail) {
        return <ErrorCard />;
    }

    return (
        <div>
            <MainContainer
                pageName={`${impExpIsNewEntry ? "New " : "Update "} ${entryLabel} Entry`}
                breadcrumbs={["Account", entryLabel]}
                prevPage={{
                    show: true,
                    onClick: handleClickPrev,
                }}
            >
                <Card shadow="sm" radius="sm" className={stickyParentClass}>
                    <form onSubmit={handleSubmit} autoComplete="off" >
                        <CardBody>
                            <div className="border-1 boeder-gray-200 p-2  my-2">
                                {Object.keys(inputBoxes.Section1).map((key, ind) => (
                                    <div key={key + ind}  >
                                        <div className={` ${isMobile && key == "Row3" ? 'flex-wrap' : ''}  flex gap-4 items-baseline mb-2 `} >
                                            {inputBoxes.Section1[key].map((item, key) =>
                                                item.type == ENUM_INPUT_TYPE.select ? (
                                                    <Select
                                                        isVirtualized
                                                        name={item?.name}
                                                        placeholder="--select--"
                                                        label={item?.placeholder}
                                                        isInvalid={errors[item.name]}
                                                        errorMessage={errors[item.name]}
                                                        labelPlacement="outside"
                                                        selectionMode="single"
                                                        isRequired={item.isrequired}
                                                        //value={formData[item.name]}
                                                        items={item.data ? item.data : []}
                                                        onChange={handleChange}
                                                        classNames={{
                                                            label: "text-xs text-black font-bold",
                                                        }}
                                                        selectedKeys={[String(formData[item.name])]}
                                                    >
                                                        {(list) => {
                                                            return (
                                                                <SelectItem key={list[item.itemkey]}>
                                                                    {list[item.itemvalue]}
                                                                </SelectItem>
                                                            );
                                                        }}
                                                    </Select>
                                                ) : item.type == ENUM_INPUT_TYPE.autocomplete ? (
                                                    <Autocomplete
                                                        size="sm"
                                                        name={item.name}
                                                        isInvalid={errors[item.name]}
                                                        errorMessage={errors[item.name]}
                                                        label={item?.placeholder}
                                                        eventResizeFeature={true}
                                                        selectionMode="single"
                                                        showScrollIndicators={true}
                                                        labelPlacement={"outside"}
                                                        menuTrigger={"input"}
                                                        placeholder={item.placeholder}
                                                        isRequired={item.isrequired}
                                                        isLoading={isLoadingData}
                                                        className="max-w-23"
                                                        classNames={{
                                                            label:
                                                                item.name == formField.partyId ||
                                                                    item.name == formField.bookId
                                                                    ? "font-bold"
                                                                    : "text-xs  text-black  font-bold",
                                                        }}
                                                        variant={
                                                            item.name == formField.partyId ||
                                                                item.name == formField.bookId ||
                                                                item.name == formField.entryType ||
                                                                item.name == formField.bankBranchId
                                                                ? "flat"
                                                                : "bordered"
                                                        }
                                                        color={
                                                            item.name == formField.partyId
                                                                ? "danger"
                                                                : item.name == formField.bookId
                                                                    ? "success"
                                                                    : item.name == formField.entryType
                                                                        ? "warning"
                                                                        : item.name == formField.bankBranchId
                                                                            ? "warning"
                                                                            : ""
                                                        }
                                                        isClearable={false}
                                                        isVirtualized
                                                        isReadOnly={!impExpIsNewEntry && item.name == formField.entryType ? true : false}
                                                        defaultItems={
                                                            item.data ? item.data : []
                                                        }
                                                        onSelectionChange={(e) =>
                                                            handleAutoCompleteChange(e, item.name)
                                                        }
                                                        selectedKey={String(formData[item.name])}
                                                    >
                                                        {(list) => (
                                                            <AutocompleteItem

                                                                key={list[item.itemkey]}
                                                            >
                                                                {list[item.itemvalue]}
                                                            </AutocompleteItem>
                                                        )}
                                                    </Autocomplete>
                                                ) : item.type == ENUM_INPUT_TYPE.date ? (
                                                    <div className=" w-full flex items-end">
                                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                            <DatePicker
                                                                name={item.name}
                                                                label={item.placeholder}
                                                                views={["day", "month", "year"]}
                                                                format="DD/MM/YYYY"
                                                                value={
                                                                    formData[item.name]
                                                                        ? dayjs(formData[item.name])
                                                                        : formData[item.name]
                                                                }
                                                                onChange={(newValue) => handleDateChange(newValue, item.name)}


                                                                className="w-full "
                                                                slotProps={{
                                                                    textField: {
                                                                        size: "small", error: errors[item.name], helperText: errors[item.name], required: true
                                                                        , onBlur: handleDateBlur,

                                                                    },
                                                                }}
                                                            />
                                                        </LocalizationProvider>
                                                    </div>
                                                ) : item.name == formField.invoiceNo && !funIsPaymentEntry() ? "" : (
                                                    <>
                                                        <Input
                                                            type={item.type}
                                                            name={item.name}
                                                            autoComplete="off"
                                                            aria-label={item.placeholder}
                                                            placeholder={item.placeholder}
                                                            isInvalid={errors[item.name]}
                                                            errorMessage={errors[item.name]}
                                                            label={item.placeholder}
                                                            labelPlacement="outside"
                                                            // onWheel={handleWheel}
                                                            isRequired={item.isrequired}
                                                            value={formData[item.name]}
                                                            classNames={{
                                                                label:
                                                                    item.name == formField.partyCurBal ||
                                                                        item.name == formField.bookCurBal
                                                                        ? "font-semibold "
                                                                        : "text-xs  font-semibold",
                                                            }}
                                                            variant={
                                                                item.name == formField.partyCurBal ||
                                                                    item.name == formField.bookCurBal
                                                                    ? "flat"
                                                                    : "bordered"
                                                            }
                                                            isReadOnly={
                                                                item.name == formField.invoiceNo ||
                                                                    item.name == formField.voucherNo
                                                                    ? true
                                                                    : false
                                                            }
                                                            color={
                                                                item.name == formField.partyCurBal
                                                                    ? "warning"
                                                                    : item.name == formField.bookCurBal
                                                                        ? "primary"
                                                                        : ""
                                                            }
                                                            size={"md"}
                                                            onChange={handleChange}
                                                        ></Input>
                                                        {item.name == formField.invoiceNo && funIsPaymentEntry() ? <Button
                                                            color="danger"
                                                            size="sm"
                                                            className="w-full uppercase font-bold text-xs  text-white rounded-sm"
                                                            onPress={handleBtnClick}
                                                            isDisabled={impExpIsNewEntry ? false : true}
                                                        >
                                                            Show Bills
                                                        </Button> : ""}
                                                    </>
                                                )
                                            )}
                                        </div>
                                    </div>
                                ))}

                            </div>
                            {/* <div className="text-center w-full mb-1">
                                <Checkbox size="md"
                                    classNames={{ "label": "text-green-700 text-xs font-semibold" }}
                                    className="py-1 px-2 mt-2  " color={"success"} isSelected={isAmountFromBill} onValueChange={(e) => handleChkboxChange(e)} >Amount From Bill Selection</Checkbox>
                            </div> */}


                            <Drawer isOpen={isOpen} isDismissable={false} placement="top" onOpenChange={onOpenChange}>
                                <DrawerContent>
                                    {(onClose) => (
                                        <>
                                            <DrawerHeader className="">
                                                Bills Detail
                                            </DrawerHeader>
                                            <DrawerBody>
                                                <div
                                                    className="p-2  border-2 border-b-rose-400  uppercase text-sky-700 font-bold text-sm">
                                                    Bills Detail
                                                </div>
                                                <BillsDetail
                                                    handleBillsDetail={handleBillsDetail}
                                                    billData={billData}
                                                    entryType={selVouType == "G" ? ENUM_TRANSACTION_TYPE.PAYMENT : ENUM_TRANSACTION_TYPE.RECEIVE}
                                                    payCurrency={"$"}
                                                />
                                            </DrawerBody>
                                            <DrawerFooter className="flex justify-between">
                                                {billData && billData.length <= 100 ? (
                                                    <h6 className="text-sm text-pink-500">
                                                        Total Bills :{billData ? billData.length : 0}
                                                    </h6>
                                                ) : (
                                                    ""
                                                )}
                                                <Button color="danger" size="sm" variant="bordered" onPress={onClose}>
                                                    Close
                                                </Button>
                                            </DrawerFooter>
                                        </>
                                    )}
                                </DrawerContent>
                            </Drawer>

                            <div className="flex gap-2 border-1 border-pink-200 p-2 my-2">
                                {funIsPaymentEntry() ?
                                    <div className="w-full">
                                        <div className="flex gap-2">
                                            {renderInput({ ...inputBoxParam, color: "warning", type: ENUM_INPUT_TYPE.date, name: formField.invoiceDate, placeholder: "Invoice Date" })}
                                            {renderInput({ ...inputBoxParam, color: "warning", name: formField.invAmountD, placeholder: "Inv. Amt $." })}
                                            {renderInput({ ...inputBoxParam, color: "warning", name: formField.balAmountD, placeholder: "O/S Amt $." })}

                                        </div>
                                        <div className="flex gap-2">
                                            {renderInput({ ...inputBoxParam, color: "warning", name: formField.dueDays, placeholder: "Due Days" })}
                                            {renderInput({ ...inputBoxParam, color: "warning", name: formField.invConvRate, placeholder: "Cnv.Rate" })}


                                        </div>
                                        <div className="flex gap-2">
                                            {renderInput({ ...inputBoxParam, color: "warning", type: ENUM_INPUT_TYPE.date, name: formField.dueDate, placeholder: "Due Date" })}
                                            {renderInput({ ...inputBoxParam, color: "warning", name: formField.invAmount, placeholder: "Inv. Amt. Rs." })}
                                            {renderInput({ ...inputBoxParam, color: "warning", name: formField.balAmount, placeholder: "O/S Amt. Rs." })}


                                        </div>

                                    </div>
                                    :
                                    <div className={`${funIsPaymentEntry() ? "" : "w-full"}`}>
                                        {renderInput({ ...inputBoxParam, variant: "bordered", color: "default", name: formField.trfAmtD, placeholder: "Trf. Amount $", required: getAmtType() == '$' ? true : false, readonly: getAmtType() == '$' ? false : true })}
                                        {renderInput({ ...inputBoxParam, variant: "bordered", color: "default", name: formField.trfConvRate, placeholder: "Cnv Rate", required: false, readonly: false })}
                                        {renderInput({ ...inputBoxParam, variant: "bordered", color: "default", name: formField.trfAmt, placeholder: "Trf. Amount Rs.", required: getAmtType() == 'RS' ? true : false, readonly: getAmtType() == '$' ? true : false })}
                                    </div>
                                }
                            </div>
                            <div className="border-1 border-sky-200 p-2">
                                <Tabs color="primary" radius="none" className="" variant="bordered">
                                    <Tab key="Main" title="Main">
                                        <div className="flex gap-2 w-full " >
                                            <div className="w-full">
                                                <div className="flex gap-2">
                                                    {funIsPaymentEntry() ?
                                                        <>
                                                            <Autocomplete
                                                                isVirtualized
                                                                name={formField.payType}
                                                                placeholder="--select--"
                                                                label={"Part/Full"}
                                                                size="sm"
                                                                isInvalid={errors[formField.payType]}
                                                                errorMessage={errors[formField.payType]}
                                                                labelPlacement="outside"
                                                                selectionMode="single"
                                                                isRequired={true}
                                                                color="danger"
                                                                onSelectionChange={(e) => handleAutoCompleteChange(e, formField.payType)}
                                                                defaultItems={ENUM_BILL_TYPE_LIST.filter(ele => ele.key != "")}
                                                                classNames={{
                                                                    label: "text-xs  font-semibold",
                                                                }}
                                                                selectedKey={(formData[formField.payType])}
                                                            >
                                                                {(list) => {
                                                                    return (
                                                                        <AutocompleteItem key={list.key}>
                                                                            {list.value}
                                                                        </AutocompleteItem>
                                                                    );
                                                                }}
                                                            </Autocomplete>
                                                            {renderInput({ ...inputBoxParam, color: "danger", name: formField.convRate, placeholder: "Cnv. Rate", readonly: false })}
                                                        </>
                                                        : ""}
                                                    {renderInput({ ...inputBoxParam, color: "danger", name: formField.partyBank, placeholder: "Party Bank", readonly: false })}

                                                </div>
                                                <div className="flex gap-2">
                                                    {funIsPaymentEntry() ?
                                                        <>
                                                            {renderInput({ ...inputBoxParam, color: "success", name: formField.invSetOffAmtD, placeholder: "Inv. Set off Amt. $", readonly: false })}
                                                            {renderInput({ ...inputBoxParam, color: "success", name: formField.invSetOffAmt, placeholder: "Inv. Set off Amt. Rs", })}
                                                        </> : ""}
                                                    {renderInput({ ...inputBoxParam, color: "success", name: formField.bankCommision, placeholder: "(+) Bank Comm.", required: false, readonly: false })}
                                                </div>
                                                <div className="flex gap-2">
                                                    {funIsPaymentEntry() ?
                                                        <>
                                                            {renderInput({ ...inputBoxParam, color: "warning", name: formField.addAmountD, placeholder: "(+) Amt. $", readonly: false })}
                                                            {renderInput({ ...inputBoxParam, color: "warning", name: formField.addAmount, placeholder: "(+) Amt. Rs", })}
                                                        </> : ""}
                                                    {renderInput({ ...inputBoxParam, color: "warning", name: formField.insurance, placeholder: "(+) Insurance", required: false, readonly: false })}
                                                </div>
                                                <div className="flex gap-2">
                                                    {funIsPaymentEntry() ?
                                                        <>
                                                            {renderInput({ ...inputBoxParam, color: "warning", name: formField.lessAmountD, placeholder: "(-) Amt. $", readonly: false })}
                                                            {renderInput({ ...inputBoxParam, color: "warning", name: formField.lessAmount, placeholder: "(-) Amt. Rs" })}
                                                        </> : ""}
                                                    {renderInput({ ...inputBoxParam, color: "warning", name: formField.otherChages, placeholder: "(+) Other Charge", required: false, readonly: false })}
                                                </div>
                                                <div className="flex gap-2">

                                                    {renderInput({ ...inputBoxParam, color: "danger", name: formField.netAmountD, placeholder: selVouType == "G" ? "Net Paid Amt. $" : "Net Rec. Amt. $", })}
                                                    {renderInput({ ...inputBoxParam, color: "danger", name: formField.netAmount, placeholder: selVouType == "G" ? "Amount Paid Rs" : "Amount Rec. Rs", })}

                                                    {renderInput({ ...inputBoxParam, color: "danger", name: formField.totalCharge, placeholder: "Total Charges", required: false, })}
                                                </div>
                                                <div className="flex gap-2">
                                                    {funIsPaymentEntry() ?
                                                        <>
                                                            {renderInput({ ...inputBoxParam, color: "warning", name: formField.rateDiff, placeholder: "Exc.Rt. Diff(+)", })}
                                                            {renderInput({ ...inputBoxParam, color: "warning", name: formField.rateDiffMns, placeholder: "Exc.Rt. Diff(-)", })}
                                                        </> : ""}
                                                    {renderInput({ ...inputBoxParam, color: "warning", name: formField.totalChargeWithTax, placeholder: "Total Charges + Tax", required: false, })}
                                                </div>
                                            </div>
                                            <div className="">
                                                <div className="flex gap-2">
                                                    {renderInput({ ...inputBoxParam, variant: "bordered", color: "default", name: formField.cGstPer, placeholder: "CGST", readonly: tradeType == 'OGS' ? true : false })}
                                                    {renderInput({ ...inputBoxParam, variant: "bordered", color: "default", name: formField.cGstAmt, placeholder: "Amount", })}

                                                </div>
                                                <div className="flex gap-2">
                                                    {renderInput({ ...inputBoxParam, variant: "bordered", color: "default", name: formField.sGstPer, placeholder: tradeType == 'OGS' ? "IGST" : "SGST", readonly: false })}
                                                    {renderInput({ ...inputBoxParam, variant: "bordered", color: "default", name: formField.sGstAmt, placeholder: "Amount" })}

                                                </div>
                                                <div>
                                                    {renderInput({ ...inputBoxParam, color: "success", name: formField.totalGst, placeholder: "Total Gst" })}
                                                </div>
                                                <div className="p-7">

                                                </div>
                                                <div>
                                                    {renderInput({ ...inputBoxParam, color: "danger", name: formField.totalAmount, placeholder: selVouType == "G" ? "Total Amount Paid" : "Total Amount Receive", })}
                                                </div>
                                            </div>
                                        </div>
                                        <div className={` flex gap-4 item-center mb-2 `}>
                                            <Textarea
                                                type="text"
                                                name={formField.remark}
                                                placeholder={"Remarks"}
                                                label={"Remark"}
                                                labelPlacement="outside"
                                                variant="bordered"
                                                classNames={{
                                                    label: "text-xs text-black font-bold",
                                                }}
                                                value={formData[formField.remark]}
                                                size={"md"}
                                                onChange={handleChange}
                                            >

                                            </Textarea>
                                            <Textarea
                                                type="text"
                                                name={formField.chargesRemark}
                                                placeholder={"Charges Remarks"}
                                                label={"Charges Remark"}
                                                labelPlacement="outside"
                                                variant="bordered"
                                                classNames={{
                                                    label: "text-xs text-black font-bold",
                                                }}
                                                value={formData[formField.chargesRemark]}
                                                size={"md"}
                                                onChange={handleChange}
                                            >

                                            </Textarea>
                                        </div>
                                    </Tab>
                                    <Tab key="Account" title="Account Remittance">
                                        <div className="my-5">
                                            {Object.keys(inputBoxes.Section4).map((key, ind) => (
                                                <div key={key + ind}   >
                                                    <div className={` ${isMobile && key == "Row3" ? 'flex-wrap' : ''}  flex gap-4 items-baseline mb-2 `} >
                                                        {inputBoxes.Section4[key].map((item, key) =>
                                                            item.type == ENUM_INPUT_TYPE.select ? (
                                                                <Select
                                                                    isVirtualized
                                                                    name={item?.name}
                                                                    placeholder="--select--"
                                                                    label={item?.placeholder}
                                                                    isInvalid={errors[item.name]}
                                                                    errorMessage={errors[item.name]}
                                                                    labelPlacement="outside"
                                                                    selectionMode="single"
                                                                    isRequired={item.isrequired}
                                                                    //value={formData[item.name]}
                                                                    items={item.data ? item.data : []}
                                                                    onChange={handleChange}
                                                                    classNames={{
                                                                        label: "text-xs text-black font-bold",
                                                                    }}
                                                                    selectedKeys={[String(formData[item.name])]}
                                                                >
                                                                    {(list) => {
                                                                        return (
                                                                            <SelectItem key={list[item.itemkey]}>
                                                                                {list[item.itemvalue]}
                                                                            </SelectItem>
                                                                        );
                                                                    }}
                                                                </Select>
                                                            ) : item.type == ENUM_INPUT_TYPE.autocomplete ? !funIsPaymentEntry() &&
                                                                [formField.addAcId, formField.jvTrn_A, formField.lessAcId, formField.jvTrn_L, formField.rateDiffAcId, formField.JvTrn_Rd].includes(item.name) ? "" : (
                                                                <Autocomplete
                                                                    size="sm"
                                                                    name={item.name}
                                                                    isInvalid={errors[item.name]}
                                                                    errorMessage={errors[item.name]}
                                                                    label={item?.placeholder}
                                                                    eventResizeFeature={true}
                                                                    selectionMode="single"
                                                                    showScrollIndicators={true}
                                                                    labelPlacement={"outside"}
                                                                    menuTrigger={"input"}
                                                                    placeholder={item.placeholder}
                                                                    isRequired={item.isrequired}
                                                                    isLoading={isLoadingData}
                                                                    className="max-w-23 font-semibold text-xs "
                                                                    isVirtualized
                                                                    variant={
                                                                        "flat"
                                                                    }
                                                                    color={item.name == formField.lessAcId ||
                                                                        item.name == formField.addAcId
                                                                        ? "warning" : "danger"
                                                                    }
                                                                    // isClearable={true}

                                                                    //readonly={item.name==formData.}
                                                                    defaultItems={
                                                                        item.data ? item.data : []
                                                                    }
                                                                    onSelectionChange={(e) =>
                                                                        handleAutoCompleteChange(e, item.name)
                                                                    }
                                                                    selectedKey={formData[item.name]}
                                                                >
                                                                    {(list) => (
                                                                        <AutocompleteItem

                                                                            key={list[item.itemkey]}
                                                                        >
                                                                            {list[item.itemvalue]}
                                                                        </AutocompleteItem>
                                                                    )}
                                                                </Autocomplete>
                                                            ) : item.type == ENUM_INPUT_TYPE.date ? (
                                                                <div className=" w-full flex items-end">
                                                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                                        <DatePicker
                                                                            name={item.name}
                                                                            label={item.placeholder}
                                                                            views={["day", "month", "year"]}
                                                                            format="DD/MM/YYYY"
                                                                            value={
                                                                                formData[item.name]
                                                                                    ? dayjs(formData[item.name])
                                                                                    : formData[item.name]
                                                                            }
                                                                            onChange={(newValue) => handleDateChange(newValue, item.name)}


                                                                            className="w-full "
                                                                            slotProps={{
                                                                                textField: {
                                                                                    size: "small", error: errors[item.name], helperText: errors[item.name], required: true
                                                                                    , onBlur: handleDateBlur,

                                                                                },
                                                                            }}
                                                                        />
                                                                    </LocalizationProvider>
                                                                </div>
                                                            ) : [formField.jvTrn_A, formField.jvTrn_L, formField.JvTrn_Rd].includes(item.name) ? "" : (

                                                                <Input
                                                                    type={item.type}
                                                                    name={item.name}
                                                                    autoComplete="off"
                                                                    aria-label={item.placeholder}
                                                                    placeholder={item.placeholder}
                                                                    isInvalid={errors[item.name]}
                                                                    errorMessage={errors[item.name]}
                                                                    label={item.placeholder}
                                                                    labelPlacement="outside"
                                                                    // onWheel={handleWheel}
                                                                    isRequired={item.isrequired}
                                                                    value={formData[item.name]}
                                                                    classNames={{
                                                                        label:
                                                                            item.name == formField.partyCurBal ||
                                                                                item.name == formField.bookCurBal
                                                                                ? "font-bold "
                                                                                : "text-xs  font-semibold",
                                                                    }}
                                                                    variant={
                                                                        item.name == formField.partyCurBal ||
                                                                            item.name == formField.bookCurBal
                                                                            ? "flat"
                                                                            : "bordered"
                                                                    }
                                                                    isReadOnly={
                                                                        item.name == formField.partyCurBal ||
                                                                            item.name == formField.bookCurBal ||
                                                                            item.name == formField.voucherNo
                                                                            ? true
                                                                            : false
                                                                    }
                                                                    color={
                                                                        item.name == formField.partyCurBal
                                                                            ? "warning"
                                                                            : item.name == formField.bookCurBal
                                                                                ? "primary"
                                                                                : ""
                                                                    }
                                                                    size={"md"}
                                                                    onChange={handleChange}
                                                                ></Input>

                                                            )
                                                        )}
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </Tab>
                                </Tabs>

                            </div>
                        </CardBody>
                        <div className={stickyBottomClass}>
                            <div className="justify-center flex items-center gap-4">
                                <Button
                                    color="primary"
                                    type="submit"
                                    id="btnSave"
                                    size="sm"
                                    variant="shadow"
                                     className="uppercase font-semibold"
                                    startContent={<FontAwesomeIcon icon={faSave} />}
                                >
                                    Submit
                                </Button>
                                <Button
                                    id="btnSaveNew"
                                    color="success"
                                    type="submit"
                                    size="sm"
                                    variant="shadow"
                                    className="text-white uppercase font-semibold"
                                    startContent={<FontAwesomeIcon className=" text-md text-white" icon={faFile} />}
                                >
                                    Save & New
                                </Button>
                                <Button
                                    color="danger"
                                    variant="shadow"
                                    size="sm"
                                     className="uppercase font-semibold"
                                    onPress={handleClickPrev}
                                    startContent={<FontAwesomeIcon icon={faCancel} />}
                                >
                                    Cancel
                                </Button>
                            </div>
                        </div>

                    </form>
                </Card>
            </MainContainer>
        </div>
    );
};
export default CreateDollarPayEntry;
